<template>
  <div class="mt-6 bg-white rounded-lg p-6">
    <!-- Planners and Others Table -->
    <div class="mb-8">
      <div class="flex justify-between mb-6">
        <h2 class="text-xl font-semibold text-gray-800">
          Planuotojai ir administracija
        </h2>
      </div>

      <div class="overflow-x-auto">
        <table class="table w-full">
          <thead>
            <tr>
              <th>Vardas, Pavardė</th>
              <th>Pareigos</th>
              <th>Telefonas</th>
              <th>El. paštas</th>
              <th>Statusas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userStore.users" :key="user.id">
              <td>{{ user.name }} {{ user.surname }}</td>
              <td>{{ roleConfig[user.role].text || user.role }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.email }}</td>
              <td>
                <span
                  :class="[
                    'badge badge-outline',
                    'text-white',
                    statusConfig[user.status].class,
                  ]"
                >
                  {{ statusConfig[user.status].text || "dirba" }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";

const userStore = useAuthStore();

const roleConfig = {
  org_admin: {
    text: "Administratorius",
  },
  engineer: {
    text: "Inžinierius",
  },
  admin: {
    text: "Administratorius",
  },
};

const statusConfig = {
  working: {
    text: "Dirba",
    class: "badge-success",
  },
  onVacation: {
    text: "Atostogauja",
    class: "badge-warning",
  },
};

onMounted(async () => {
  try {
    await userStore.fetchUsers();
  } catch (error) {
    console.error("Failed to fetch users:", error);
  }
});
</script>
